
namespace Matrix.Exceptions {

    @Serenity.Decorators.registerClass()
    export class ExceptionReviewDialog extends Serenity.EntityDialog<ExceptionReviewRow, any> {
        protected getFormKey() { return ExceptionReviewForm.formKey; }
        protected getIdProperty() { return ExceptionReviewRow.idProperty; }
        protected getLocalTextPrefix() { return ExceptionReviewRow.localTextPrefix; }
        protected getNameProperty() { return ExceptionReviewRow.nameProperty; }
        protected getService() { return ExceptionReviewService.baseUrl; }
        protected getDeletePermission() { return ExceptionReviewRow.deletePermission; }
        protected getInsertPermission() { return ExceptionReviewRow.insertPermission; }
        protected getUpdatePermission() { return ExceptionReviewRow.updatePermission; }

        protected form = new ExceptionReviewForm(this.idPrefix);

    }
}